import Icon from '../components/Icon.vue'

Icon.register({
  'plane-departure': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM80.5 341.3C86.8 348.1 95.7 352 104.9 352L235.4 351.8A65.6-65.6 0 0 1 265.1 344.7L556 197C582.8 183.5 606.7 164.1 623 138.7 641.3 110.2 643.3 89.6 636.1 75.1 628.9 60.5 611.4 49.8 577.9 47.6 548 45.7 518.3 53.5 491.6 67.1L393.1 117.1 174.4 35A17.8-17.8 0 0 1 156.4 33.9L90.6 67.3C80 72.7 77.4 86.9 85.5 95.8L241.7 193.9 138.5 246.3 66.1 209.8A17.8-17.8 0 0 1 50 209.8L9.9 230.2C-0.5 235.5-3.3 249.3 4.3 258.3L80.5 341.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plane-departure.js
// module id = YC/C
// module chunks = 144